<div class="autorizacao-manual-shell autorizacao-manual" [ngClass]="usuario?.retorno?.aparencia ?? 'PADRAO'">
  <app-title-box
    [local]="tituloLocal"
    [mostrarBotaoFiltrar]="false"
    [mostrarBotaoVoltar]="true"
    (voltar)="voltar()"
  >
  </app-title-box>

  <app-flash-message></app-flash-message>

  <section class="secao-lista autorizacao-manual__secao autorizacao-manual__conteudo">
    <app-form-box class="autorizacao-manual__form-box">
      <header class="autorizacao-manual__form-header">
        <h3 class="autorizacao-manual__form-titulo">Dados de Abastecimento</h3>
        <p class="autorizacao-manual__form-descricao">
          Por favor, preencha os dados abaixo e garanta que batem corretamente com os valores do abastecimento.
        </p>
      </header>

      <p *ngIf="carregandoForm" class="autorizacao-manual__loading">Carregando…</p>

      <div *ngIf="!carregandoForm" class="autorizacao-manual__form-scroll">
        <div class="autorizacao-manual__form-grid">
          <!-- Linha 1: Motorista (lupa) + CPF readonly + Celular readonly -->
          <div class="autorizacao-manual__linha-motorista">
            <mat-form-field
              class="autorizacao-manual__field autorizacao-manual__field--motorista"
              appearance="outline"
            >
              <mat-label>Motorista</mat-label>
              <input
                matInput
                [(ngModel)]="modelo.nomeMotorista"
                name="pqfNome"
                placeholder="Clique na lupa para buscar um motorista"
                readonly
                required
              />
              <button
                mat-icon-button
                matSuffix
                type="button"
                (click)="abrirBuscaMotorista()"
                matTooltip="Buscar motorista"
              >
                <mat-icon>search</mat-icon>
              </button>
              <button
                *ngIf="modelo.nomeMotorista"
                mat-icon-button
                matSuffix
                type="button"
                (click)="limparMotorista()"
                matTooltip="Limpar motorista"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>

            <mat-form-field
              class="autorizacao-manual__field autorizacao-manual__field--cpf"
              appearance="outline"
            >
              <mat-label>CPF</mat-label>
              <input
                matInput
                [ngModel]="(modelo.cpfMotorista || '') | mask: '000.000.000-00'"
                name="pqfCpf"
                readonly
              />
            </mat-form-field>

            <mat-form-field
              class="autorizacao-manual__field autorizacao-manual__field--celular"
              appearance="outline"
            >
              <mat-label>Celular</mat-label>
              <input
                matInput
                [ngModel]="(modelo.celularMotorista || '') | mask: mascaraTelefone"
                name="pqfCel"
                readonly
              />
            </mat-form-field>
          </div>

          <mat-form-field
            class="autorizacao-manual__field autorizacao-manual__full"
            appearance="outline"
          >
            <mat-label>Placa</mat-label>
            <input
              matInput
              [(ngModel)]="modelo.placa"
              name="pqPlaca"
              [placeholder]="modo === 'incluir' ? placeholdersIncluir.placa : 'ABC-1234'"
              maxlength="8"
              (blur)="onPlacaBlur()"
              required
            />
            <button
              *ngIf="modelo.placa?.trim()"
              mat-icon-button
              matSuffix
              type="button"
              (click)="limparCampoPlacaForm()"
              matTooltip="Limpar placa"
              aria-label="Limpar placa"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>

          <div
            *ngIf="modo === 'repetir' && (modelo.codPosto || modelo.nomePosto)"
            class="autorizacao-manual__linha-posto"
          >
            <mat-form-field
              class="autorizacao-manual__field autorizacao-manual__field--cod-posto"
              appearance="outline"
            >
              <mat-label>Código posto</mat-label>
              <input matInput [(ngModel)]="modelo.codPosto" name="pqCodPosto" readonly />
            </mat-form-field>
            <mat-form-field
              class="autorizacao-manual__field autorizacao-manual__field--nome-posto"
              appearance="outline"
            >
              <mat-label>Posto</mat-label>
              <input matInput [(ngModel)]="modelo.nomePosto" name="pqNomePosto" readonly />
            </mat-form-field>
          </div>

          <mat-form-field
            class="autorizacao-manual__field autorizacao-manual__full"
            appearance="outline"
          >
            <mat-label>Combustível</mat-label>
            <mat-select [(ngModel)]="modelo.cdProduto" name="pqComb" required>
              <mat-option value="">Selecione o combustível</mat-option>
              <mat-option
                *ngFor="let c of combustiveis"
                [value]="c.codCombustivel.toString()"
              >
                {{ c.dscCombustivel }}
              </mat-option>
            </mat-select>
            <button
              *ngIf="modelo.cdProduto"
              mat-icon-button
              matSuffix
              type="button"
              (click)="limparCombustivelSelecionado()"
              matTooltip="Limpar combustível"
              aria-label="Limpar combustível"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>

          <mat-form-field
            class="autorizacao-manual__field autorizacao-manual__full"
            appearance="outline"
          >
            <mat-label>Valor por Litro (R$)</mat-label>
            <input
              matInput
              type="number"
              step="0.01"
              min="0"
              [max]="LIMITES.PRECO_UNITARIO_MAX"
              inputmode="decimal"
              [(ngModel)]="modelo.precoUnitario"
              name="pqPreco"
              (blur)="recalcularValorTotal()"
              [placeholder]="modo === 'incluir' ? placeholdersIncluir.preco : 'R$ 0,00'"
              required
            />
            <button
              *ngIf="campoNumeroComValor(modelo.precoUnitario)"
              mat-icon-button
              matSuffix
              type="button"
              (click)="limparPrecoUnitarioCampo()"
              matTooltip="Limpar valor por litro"
              aria-label="Limpar valor por litro"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>

          <mat-form-field
            class="autorizacao-manual__field autorizacao-manual__full"
            appearance="outline"
          >
            <mat-label>Litros *</mat-label>
            <input
              matInput
              type="number"
              step="0.01"
              min="0"
              [max]="LIMITES.LITROS_MAX"
              inputmode="decimal"
              [(ngModel)]="modelo.litros"
              name="pqLitros"
              (blur)="recalcularValorTotal()"
              [placeholder]="modo === 'incluir' ? placeholdersIncluir.litros : '0,00'"
            />
            <button
              *ngIf="campoNumeroComValor(modelo.litros)"
              mat-icon-button
              matSuffix
              type="button"
              (click)="limparLitrosCampo()"
              matTooltip="Limpar litros"
              aria-label="Limpar litros"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>

          <mat-form-field
            class="autorizacao-manual__field autorizacao-manual__full"
            appearance="outline"
          >
            <mat-label>Valor Total (R$) *</mat-label>
            <input
              matInput
              type="number"
              step="0.01"
              min="0"
              [max]="LIMITES.VALOR_TOTAL_MAX"
              inputmode="decimal"
              [(ngModel)]="modelo.valorTotal"
              name="pqVtot"
              (blur)="recalcularLitros()"
              [placeholder]="modo === 'incluir' ? placeholdersIncluir.valorTotal : 'R$ 0,00'"
            />
            <button
              *ngIf="campoNumeroComValor(modelo.valorTotal)"
              mat-icon-button
              matSuffix
              type="button"
              (click)="limparValorTotalCampo()"
              matTooltip="Limpar valor total"
              aria-label="Limpar valor total"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>

          <mat-form-field
            class="autorizacao-manual__field autorizacao-manual__full"
            appearance="outline"
          >
            <mat-label>Hodômetro (KM)</mat-label>
            <input
              matInput
              type="number"
              step="1"
              min="0"
              [max]="LIMITES.HODOMETRO_MAX"
              inputmode="numeric"
              [(ngModel)]="modelo.hodometro"
              name="pqHodo"
              [placeholder]="modo === 'incluir' ? placeholdersIncluir.hodometro : '0'"
              required
            />
            <button
              *ngIf="campoNumeroComValor(modelo.hodometro)"
              mat-icon-button
              matSuffix
              type="button"
              (click)="limparHodometroCampo()"
              matTooltip="Limpar hodômetro"
              aria-label="Limpar hodômetro"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>

          <div class="autorizacao-manual__bypass-banner">
            <mat-checkbox
              [(ngModel)]="bypassMarcado"
              name="pqBypass"
              class="autorizacao-manual__bypass-check"
            >
              ByPass - Não executar regras de bloqueio (Ex: Restrição de horário)
            </mat-checkbox>
          </div>
        </div>
      </div>

      <div form-box-footer class="autorizacao-manual__footer">
        <button
          mat-flat-button
          type="button"
          class="autorizacao-manual__btn-confirmar"
          (click)="confirmar()"
        >
          <mat-icon>save</mat-icon>
          Confirmar
        </button>
        <button mat-stroked-button type="button" (click)="voltar()">
          Cancelar
        </button>
      </div>

      <p class="autorizacao-manual__obrigatorios">
        * Campos obrigatórios são obrigatórios
      </p>
    </app-form-box>
  </section>
</div>
